export const VNSCANNER_INITIALIZED = 'VNSCANNER_INITIALIZED'
export const USING_VNSCANNER = 'USING_VNSCANNER'
export const SCANNER_RESULTS = 'SCANNER_RESULTS'
export const VNSCANNER_PERMISSIONS_ALLOWED = 'VNSCANNER_PERMISSIONS_ALLOWED'
